import { Link } from "react-router-dom";
import { Icon } from "components";
import { PROJECT, CONTRACT, RIGHT } from "icons";
import { useContract } from "../context";
import { ROUTE } from "@/lib/utils";

export const ContractBreadcrumbs = () => {
  const { contract } = useContract();
  if (!contract) return null;

  return (
    <nav className="flex items-center text-sm ">
      <Link
        to={ROUTE.PROJECT(contract?.project?.project_id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={PROJECT} className="size-4 text-muted-foreground" />
        <span className="font-medium truncate max-w-[220px]">
          {contract?.project?.name}
        </span>
      </Link>

      <Icon icon={RIGHT} className="text-muted-foreground" />
      <div className="flex items-center gap-2 px-2 py-1">
        <Icon icon={CONTRACT} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[260px] font-medium">
          {contract?.name ?? "contract"}
        </span>
      </div>
    </nav>
  );
};
